<template>
  <div>
    <div class="app-content content devcontent">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
          <div class="container-fluid">
            <div class="row breadcrumbs-top">
              <div class="col-md-12 content-header-left px-0">
                <h3 class="content-header-title float-left mb-0">
                  Accident Management
                </h3>
                <div class="breadcrumb-wrapper">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <router-link to="#">
                        Dashboard </router-link
                      >
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-body">
          <section>
            <div class="card">
              <div class="card-header px-0 common_top_title_searchbgst_dock">
                <div class="container-fluid">
                  <div class="row row fc_my-05">
                    <div class="w-auto px-1 mobile-padding-0-2">
                      <div
                        class="avatar bg-light-secondary rounded d-inline-flex mr-1"
                      >
                        <div class="avatar-content">
                          <i
                            class="i_icon_st la-people-carry las lab font-medium-5"
                          ></i>
                        </div>
                      </div>
                      <h4 class="card-title d-inline-flex ml-0 mb-0">
                        Accident Reports
                      </h4>
                    </div>
                    <div class="col-12 col-sm">
                      <div class="d-flex justify-content-end mt-2 mt-sm-0">
                        <button class="btn btn-primary" @click="onCreateFormHandler">Create</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 px-0">
                <div class="card text-center mb-1">
                  <div
                    class="card-card-header text-editar_discription_jobs masters_detailstabing_pills px-0"
                  >
                    <div
                      class="nav-tabs epg-tabs subcategory-tabs no-bg scroll-both"
                    >
                      <nav class="nav-tabs-wrapper main_divtabsview">
                        <ul
                          class="tabs_masters_detailstabing_pills nav nav-pills nav-pill-primary pb-0 nav-tabs-items dragscroll"
                        >
                          <li
                            class="nav-item tabs-item active main_divtabsviewtoggle"
                            data-day="1"
                          ></li>
                        </ul>
                      </nav>
                    </div>

                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane active"
                        id="accident_form">
                        <div>
                          <div class="table-responsive datatableview">
                            <vue-element-loading
                            spinner="bar-fade-scale"
                            :active="isMasterListLoading"
                          />         
                              <table class="table table-hover table_stickys table-striped table-col-td-white custom_doctable">
                                <thead>
                                    <tr>
                                        <th colspan="2" class="text-left align-middle">
                                            <i class="las la-plus-circle"></i>
                                            Accident Report
                                        </th>
                                        <th  colspan="7" class="text-left align-middle">
                                          Action
                                      </th>
                                    </tr>
                                </thead>

                                      <tbody>
                                          <template v-for="(data,index) in accident_form.list"  >
                                              <tr>
                                                  <td data-column="Vehicle details"  class="text-left merge_column_detals">
                                                      <div class="meger_details"> 
                                                          <span class="title_name_text"> Vehicle :</span>
                                                          <span class="title_value_text"> {{data.vehicle_id}}</span>
                                                      </div>
                                                      <hr>
                                                      <div class="meger_details"> 
                                                          <span class="title_name_text"> Driver Name :</span>
                                                          <span class="title_value_text"> {{data.driver_name}}</span>
                                                      </div>
                                                      <hr>
                                                      <div class="meger_details"> 
                                                          <span class="title_name_text"> Mobile:</span>
                                                          <span class="title_value_text"> {{ data.mobile }}</span>
                                                      </div>
                                                  </td>                                                                
                                                  <td data-column="Handover Confirmation Details"  class="text-left merge_column_detals">
                                                      
                                                      <div class="meger_details"> 
                                                          <span class="title_name_text"> Landmark:</span><br/>
                                                          <span class="title_value_text"> {{data.landmark}}</span>
                                                      </div>
                                                      <hr>
                                                      <div class="meger_details"> 
                                                          <span class="title_name_text"> Comment/Reason:</span><br/>
                                                          <span class="title_value_text"> {{ data.comment }}</span>
                                                      </div>
                                                      <div class="meger_details"> 
                                                          <span class="title_name_text"> Accident Type:</span><br/>
                                                          <span class="title_value_text"> {{ data.accidenttype }}</span>
                                                      </div>
                                                  </td>
                                                  <td data-column="Action" class="text-left merge_column_detals">
                                                    <span> 
                                                      <i class="las la-edit"></i>
                                                      <a v-on:click="getId(data.accident_id)" href="javascript:void(0);">Edit</a>
                                                    
                                                    </span>
                                                  </td>
                                                  <!-- <td data-column="Photo details"  class="text-left merge_column_detals photo_details_doc_borders">
                                                      <div class="daily_transaction_photos_details">
                                                          <ul>
                                                          <li> 
                                                              <div class="photo_details_doc_04" v-if="data.driver_photo"> 
                                                                  <div  class="innerphoto_details_doc_04"  >
                                                                      <img alt=""  class="" :src="findImageUrl('accident_form', data.driver_photo)" @click="getPhotoLink(data.driver_photo)" >
                                                                  </div>
                                                                  <h6 class="vehicle_name_text"> Driver  Photo</h6>
                                                              </div>
                                                              <div class="photo_details_doc_04"  v-else> 
                                                                  <div class="innerphoto_details_doc_04">
                                                                      <img alt=""  class="" src="images/icons/noimage.jpg" >
                                                                  </div>
                                                                  <h6 class="vehicle_name_text">Driver  Photo </h6>
                                                              </div>
                                                          </li>
                                                          <li> 
                                                              <div class="photo_details_doc_04" v-if="data.accident_photo"> 
                                                                  <div class="innerphoto_details_doc_04">
                                                                      <img alt=""  class="" :src="findImageUrl('accident_form',data.accident_photo)" @click="getPhotoLink(data.accident_photo)" >
                                                                  </div>
                                                                  <h6 class="vehicle_name_text"> Uploaded Photo </h6>
                                                              </div>
                                                              <div class="photo_details_doc_04"  v-else> 
                                                                  <div class="innerphoto_details_doc_04">
                                                                      <img alt=""  class="" src="images/icons/noimage.jpg" >
                                                                  </div>
                                                                  <h6 class="vehicle_name_text">Uploaded Photo</h6>
                                                              </div>
                                                          </li>
                                                          <li> 
                                                              <div class="photo_details_doc_04" v-if="data.FIR_copy_photo"> 
                                                                  <div class="innerphoto_details_doc_04">
                                                                      <img alt=""  class="" :src="findImageUrl('accident_form', data.FIR_copy_photo)" @click="getPhotoLink(data.FIR_copy_photo)" >
                                                                  </div>
                                                                  <h6 class="vehicle_name_text">FIR Copy Photo</h6>
                                                              </div>
                                                              <div class="photo_details_doc_04"  v-else> 
                                                                  <div class="innerphoto_details_doc_04">
                                                                      <img alt=""  class="" src="images/icons/noimage.jpg" >
                                                                  </div>
                                                                  <h6 class="vehicle_name_text">FIR Copy Photo </h6>
                                                              </div>
                                                          </li>
                                                          </ul>
                                                      </div>
                                                  </td> -->
                                              </tr>
                                          </template>
                                          <template v-if="!accident_form.list.length">
                                              <tr><td colspan="14" style="text-align: center;">No records found</td></tr>
                                          </template>
                                      </tbody>
                              </table>
                          </div>
                          <div
                            class="pageCenter text-center mt-4 pagination_viewallpages"
                          >
                            <pagination
                              v-model="accident_form.page"
                              :records="accident_form.totalcount"
                              :per-page="accident_form.pagelimit"
                              @paginate="
                                (e) => handlePageChange(e, 'accident_form')
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
  import axios from "axios";
  import moment from "moment";
  import Pagination from "vue-pagination-2";
  import DatePicker from "vue2-datepicker";
  import "vue2-datepicker/index.css";
  import Treeselect from "@riophae/vue-treeselect";
  import VueElementLoading from "vue-element-loading";
  import {
    XCircleIcon,
    FileIcon,
    UploadIcon,
    DownloadIcon,
    EditIcon,
  } from "vue-feather-icons";
  import CONSTANT from "../../constants.js";
  import common_methods from "../../utils/common_methods";
  import searchMasterNameList from "../../utils/searchMasterNameList";
  import { Cropper } from "vue-advanced-cropper";
  import "vue-advanced-cropper/dist/style.css";
  
  import 'video.js/dist/video-js.min.css';
  import videojs from 'video.js';
  import RecordRTC from 'recordrtc';
  import 'videojs-record/dist/css/videojs.record.css';
  import Record from 'videojs-record/dist/videojs.record.js';
  import FFmpegjsEngine from 'videojs-record/dist/plugins/videojs.record.ffmpegjs.js';
  
  export default {
    name: "accidentDetails",
    mixins: [common_methods, searchMasterNameList],
    components: {
      Treeselect,
      DatePicker,
      VueElementLoading,
      Pagination,
      UploadIcon,
      FileIcon,
      XCircleIcon,
      DownloadIcon,
      EditIcon,
      Pagination,
    },
    data() {
      return {
        un: "",
        isLoading: false,
        level: [
          { id: "minor", label: "Minor" },
          { id: "major", label:"Major"} ,
          { id: "fatal", label: "Fatal" },
        ],
        camera_options: [],
        camera: null,
        torch: false,
        accident_form: false,
        cropAllowed: [ "accident_photo", "FIR_copy_photo"],
        fileTitle: [ "accident_photo", "FIR_copy_photo"],
        isRecording: true,
        mediaRecorder: null,
        recordedChunks: [],
        recordedVideoURL: null,
        vehicleList: [],
        player: '',
        retake: 0,
        isSaveDisabled: false,
        isStartRecording: false,
        isRetakeDisabled: true,
        submitText: 'Submit',
        options: {
          // video.js options
          controls: true,
          bigPlayButton: false,
          controlBar: {
            deviceButton: false,
            recordToggle: false,
            pipToggle: false
          },
          loop: false,
          fluid: false,
          width: 320,
          height: 240,
          plugins: {
              // videojs-record plugin options
            record: {
                pip: false,
                image: false,
                audio: false,
                video: true,
                maxLength: 5,
                displayMilliseconds: true,
                debug: true
            }
          }
        },
        accident_form: {
          url: "/accident",
          list: [],
          totalcount: 0,
          pageCount: 0,
          page: 1,
          pagelimit: CONSTANT.LIMIT,
          currPageNum: 0,
          pageoffset: 1,
          presignedUrls: [],
        },
        formData: {
          vehicle_id: null,
          driver_name: null,
          mobile: null,
          landmark: null,
          comment: null,
          accidenttype:null
        },
        captures: {
          driver_photo: {
            stream: null,
            file: null,
            img: null,
            isCropped: false,
            showCropper: false,
          },
          accident_photo: {
            stream: null,
            file: null,
            img: null,
            isCropped: false,
            showCropper: false,
          },
          FIR_copy_photo: {
            stream: null,
            file: null,
            img: null,
            isCropped: false,
            showCropper: false,
          },
          accident: {
            file: null
          }
        },
        photoCaptureSound: "sound/iphone-camera-capture-6448.wav",
      };
    },
    created() {
      this.getCameraSelection();
      this.getVehicleList();
      this.getMasterList();
    },
    mounted() {
      },
    methods: {

      getId(id){
        let routeData = this.$router.resolve({ 
        path: `/editaccident/${id}`,
      })
      window.open(routeData.href);
      },

      onCreateFormHandler() {
      this.$router.push('/accident-management')
    },
      startRecording() {
              this.isRecording = true;
              this.player.record().getDevice();
          },
      stopRecording() {
         this.player.record().stopDevice();
         var data = this.player.recordedData;
         this.storeFile(
            new File([data], `accident_report_video_record.webm`, { type: "video/webm;codecs=vp8" }),
            "accident"
          );
      },
  
      submitVideo() {
        // this.isSaveDisabled = true;
        this.isRetakeDisabled = true;
        var data = this.player.recordedData;
        var formData = new FormData();
        formData.append('video', data, data.name);
        this.submitText = "Uploading "+data.name;
        console.log('uploading recording:', data.name);
        this.player.record().stopDevice();
        console.log(data, "__++++")
        // fetch(this.uploadUrl, {
        //     method: 'POST',
        //     body: formData,
        //     headers: {
        //         'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        //     }
        // }).then(
        //     success => {
        //         console.log('recording upload complete.');
        //         this.submitText = "Upload Complete";
        //     }
        // ).catch(
        //     error =>{
        //         console.error('an upload error occurred!');
        //         this.submitText = "Upload Failed";
        //     }
        // );
    },
  
      findImageUrl(tab, key) {
        let presignedUrls = this[tab].presignedUrls;
        let urlObj = presignedUrls.find((obj) => obj.fileKey === key);
        if (urlObj) return urlObj.url;
        return "";
      },
      getPhotoLink(key) {
        this.getPresignUrl(key)
          .then((result) => {
            this.photo_links = [result];
            // $('.imagepreview').attr('src', this.photo_link);
            // $("#imagemodal").modal("show");
          })
          .catch((e) => {
            this.displayError(e);
            this.photo_links = [];
          });
      },
      getMasterList(tab = "accident_form") {
        this.isMasterListLoading = true;
        let url = this[tab].url;
        let method = "POST";
        let payload = {
          page: this[tab].page,
          rows: this[tab].pagelimit,
        };
        this.makeRequest(method, url, payload)
          .then((result) => {
           // console.log(result.data.data.rows)
            this.isMasterListLoading = false;
            this[tab].list = result.data.data.rows;
            this[tab].totalcount = result.data.data.count;
            this[tab].pageCount = Math.ceil(
              result.data.data.count / this[tab].pagelimit
            );
            this[tab].presignedUrls = result.data.data.presignedUrls;
          })
          .catch((e) => {
            this.isMasterListLoading = false;
            this.displayError(e);
          });
      },
      handlePageChange(pageNum, tab) {
        this[tab].pageoffset = pageNum;
        this[tab].currPageNum = pageNum - 1;
  
        this.getMasterList(tab);
        setTimeout(() => {
          $("html, body").animate({
            scrollTop: $(`#${tab}`).offset().top - 70,
          });
        }, 500);
      },
      async getCameraSelection() {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(
          (device) => device.kind === "videoinput"
        );
        const options = videoDevices.map((videoDevice) => {
          return {
            id: videoDevice.deviceId,
            label: videoDevice.label,
          };
        });
        this.camera_options = options;
      },
      handleCameraSelection(id) {
        this.camera = id;
      },
      getVehicleList() {
        this.searchNameMasterList(
          "vehicle_registration_master",
          "vehicle_number_plate",
          null,
          "vehicle_id",
          "vehicle_transaction_type"
        )
          .then((result) => {
            this.vehicleList = result.data;
          })
          .catch((e) => {
            this.displayError(e);
          });
      },
      defaultSize({ imageSize, visibleArea }) {
        let width = (visibleArea || imageSize).width;
        let height = (visibleArea || imageSize).height;
        let isCropped = this.captures.driver_photo.isCropped;
        if (!isCropped) {
          return {
            width: width,
            height: height,
          };
        }
        return {
          width,
          height,
        };
      },
      accidentDefaultSize({ imageSize, visibleArea }) {
        let width = (visibleArea || imageSize).width;
        let height = (visibleArea || imageSize).height;
        let isCropped = this.captures.accident_photo.isCropped;
        if (!isCropped) {
          return {
            width: width,
            height: height,
          };
        }
        return {
          width,
          height,
        };
      },
      FIRCopyDefaultSize({ imageSize, visibleArea }) {
        let width = (visibleArea || imageSize).width;
        let height = (visibleArea || imageSize).height;
        let isCropped = this.captures.FIR_copy_photo.isCropped;
        if (!isCropped) {
          return {
            width: width,
            height: height,
          };
        }
        return {
          width,
          height,
        };
      },
    },
    beforeDestroy() {
          if (this.player) {
              this.player.dispose();
          }
      }
  };
  </script>
  <style scoped>
  .alignment {
    margin-left: 20px;
    margin-bottom: 20px;
  }
  .requiredField {
    margin-left: 2px;
    color: red;
  }
  #overlay-camera {
    position: fixed;
    display: none;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 1);
    z-index: 2;
    cursor: pointer;
  }
  
  .overlay-camera {
    position: fixed;
    display: none;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 1);
    z-index: 2;
    cursor: pointer;
  }
  .video-sm {
    max-width: 100%;
    height: 100%
  }
  </style>
  